import { render, staticRenderFns } from "./Posts.vue?vue&type=template&id=2623be41&scoped=true"
import script from "./Posts.vue?vue&type=script&lang=js"
export * from "./Posts.vue?vue&type=script&lang=js"
import style0 from "./Posts.vue?vue&type=style&index=0&id=2623be41&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2623be41",
  null
  
)

export default component.exports